import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/Service.css';

const Service = () => {
  // Sample service data
  const services = [
    {
      title: "Beginner Courses",
      description: "Perfect for those who are new to the Oromo language. Learn the basics of pronunciation, common phrases, and fundamental grammar.",
      icon: "fas fa-graduation-cap"
    },
    {
      title: "Intermediate Learning",
      description: "Build on your foundation with more complex sentence structures, expanded vocabulary, and conversational practice.",
      icon: "fas fa-comments"
    },
    {
      title: "Advanced Mastery",
      description: "Refine your skills with advanced grammar, idiomatic expressions, and cultural nuances to achieve near-native fluency.",
      icon: "fas fa-award"
    }
  ];

  // Sample learning topics
  const learningTopics = [
    {
      title: "Alphabet & Pronunciation",
      description: "Master the Oromo alphabet (Qubee) and pronunciation with interactive YouTube guides.",
      icon: "fas fa-font"
    },
    {
      title: "Vocabulary Building",
      description: "Expand your Oromo vocabulary with thematic word lists and memory techniques.",
      icon: "fas fa-book-open"
    },
    {
      title: "Grammar Fundamentals",
      description: "Learn essential grammar rules through clear explanations and practical examples.",
      icon: "fas fa-pencil-alt"
    },
    {
      title: "Conversation Practice",
      description: "Develop speaking confidence with guided dialogues and real-life scenarios.",
      icon: "fas fa-comments"
    },
    {
      title: "Cultural Insights",
      description: "Understand Oromo traditions, customs, and cultural context to enhance your language skills.",
      icon: "fas fa-globe-africa"
    },
    {
      title: "Reading & Writing",
      description: "Develop literacy skills with progressive reading materials and writing exercises.",
      icon: "fas fa-pen-fancy"
    },
    {
      title: "Listening Comprehension",
      description: "Improve your ability to understand spoken Oromo through audio exercises and native speaker recordings.",
      icon: "fas fa-headphones"
    },
    {
      title: "Idioms & Expressions",
      description: "Learn common Oromo idioms and expressions to sound more natural in your conversations.",
      icon: "fas fa-comment-dots"
    },
    {
      title: "Practical Applications",
      description: "Apply your Oromo language skills in real-world situations through role-playing and practical exercises.",
      icon: "fas fa-briefcase"
    }
  ];

  return (
    <div className="services-page">
      {/* Services Header */}
      <div className="services-header">
        <div className="container">
          <h1>Services</h1>
          <p>Comprehensive Oromo language learning solutions for all levels</p>
        </div>
      </div>

      {/* Main Services */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Learning Pathways</h2>
            <p>Choose the journey that fits your goals</p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div className="service-card" key={index}>
                <div className="service-image">
                  <div style={{ 
                    height: '100%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    backgroundColor: '#f0f4f8'
                  }}>
                    <i className={`${service.icon} fa-4x`} style={{ color: '#ff6b00' }}></i>
                  </div>
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <a href="https://youtube.com/@teachoromoolanguagebydr.ab4564" target="_blank" rel="noopener noreferrer" className="btn-primary">Explore My YouTube channel</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Learning Topics */}
      <section className="learning-topics">
        <div className="container">
          <div className="section-title">
            <h2>Learning Topics</h2>
            <p>Comprehensive curriculum covering all aspects of the Oromo language</p>
          </div>
          <div className="topics-grid">
            {learningTopics.map((topic, index) => (
              <div className="topic-card" key={index}>
                <div className="topic-icon">
                  <i className={topic.icon}></i>
                </div>
                <h3>{topic.title}</h3>
                <p>{topic.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Learning Methods */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Learning Methods</h2>
            <p>Effective approaches to language acquisition</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-image">
                <div style={{ 
                  height: '100%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  backgroundColor: '#f0f4f8'
                }}>
                  <i className="fas fa-laptop fa-4x" style={{ color: '#ff6b00' }}></i>
                </div>
              </div>
              <div className="service-content">
                <h3>Online Self-Study</h3>
                <p>Learn at your own pace with our comprehensive online YouTube platform featuring interactive lessons, quizzes, and progress tracking.</p>
              </div>
            </div>
            <div className="service-card">
              <div className="service-image">
                <div style={{ 
                  height: '100%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  backgroundColor: '#f0f4f8'
                }}>
                  <i className="fas fa-video fa-4x" style={{ color: '#ff6b00' }}></i>
                </div>
              </div>
              <div className="service-content">
                <h3>Virtual Classrooms</h3>
                <p>Join scheduled live sessions with Abdullah expert for guided learning, real-time feedback, and group interaction.</p>
              </div>
            </div>
            <div className="service-card">
              <div className="service-image">
                <div style={{ 
                  height: '100%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  backgroundColor: '#f0f4f8'
                }}>
                  <i className="fas fa-user-friends fa-4x" style={{ color: '#ff6b00' }}></i>
                </div>
              </div>
              <div className="service-content">
                <h3>One-on-One Tutoring</h3>
                <p>Get personalised attention and customised learning plans with experienced Oromo language tutors.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Start Learning Oromo?</h2>
          <p>Choose the plan that works best for you and begin your language journey today.</p>
          <div className="cta-buttons">
            <a href="https://youtube.com/@teachoromoolanguagebydr.ab4564" target="_blank" rel="noopener noreferrer" className="btn-primary">Start your Oromo language journey today</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service;